import ScrollRegister from '../motion/ScrollRegister'
import scrollHandler from '../motion/ScrollHandler'
import CONSTANT from '../config/constant'
import Utility from '../utility/Utility'
import LIB from '../utility/Library'

export default class NaviSp extends ScrollRegister {
  constructor() {
    super()
    this.elm = {
      container: document.getElementById('container'),
      header   : document.getElementById('header'),
      headerBg : document.getElementsByClassName('header-bg'),
      headerNavy: document.getElementById('header-bg-navy'),
      headerWhite: document.getElementById('header-bg-white'),
      menu     : document.getElementsByClassName('header-item'),
      menuLinks: document.querySelectorAll('.header-item a'),
      open     : document.querySelectorAll('#header-button .open'),
      close    : document.querySelectorAll('#header-button .close'),
      naviLine : document.getElementById('navi-line'),
      online   : document.querySelector('.header-button-item.mod-online')
    }
  
    this.CLASSNAME = {
      ACTIVE : 'is-active',
      LEAVE  : 'is-leave',
      VISIBLE: 'is-visible'
    }

    this.state = {
      isOpen     : false,
      isAnimating: false
    }

    this.headerHeight = this.elm.header.clientHeight
    this.naviLine     = this.elm.naviLine ? Utility.getElementBottom(this.elm.naviLine) : 0

    this.bindEvents()
  }

  bindEvents() {
    window.addEventListener('resize', () => this.handleResize())
    this.elm.header.addEventListener('click', (e) => this.toggle(e))
    this.elm.online.addEventListener('click', (e) => e.stopPropagation())

    // 他ページへのリンク時にはメニューを閉じさせない
    for (let i = 0, length = this.elm.menuLinks.length; i < length; i++) {
      this.elm.menuLinks[i].addEventListener('click', function(e) {
        if (location.pathname.toString() !== this.pathname.toString()) {
          e.stopPropagation()
        }
      })
    }
  }

  onLoad() {
    if (location.hash) {
      const id     = location.hash.replace('#', '')
      const target = document.getElementById(id)
      const title  = document.querySelector(location.hash + ' .page-title')

      // リンク時にブラウザが自動的に以前の場所にもどってしまうので、
      // 少し待ってからスクロールして表示する
      setTimeout(() => {
        Velocity(target, 'scroll', {
          duration: 1,
          easing  : 'easeInOutQuart',
          complete: () => {
            title.classList.add(CONSTANT.CLASSNAME.VISIBLE)
            setTimeout(() => {
              document.body.classList.add('is-loaded')
            }, 160)
          }
        })
      }, 600)
    }
  }

  onScrollStart(windowTop, windowBottom) {
    const scrollPos = LIB.isPc ? windowTop : windowBottom
    if (scrollPos <= this.naviLine) {
      this.elm.header.classList.remove(this.CLASSNAME.VISIBLE)
    } else {
      this.elm.header.classList.add(this.CLASSNAME.VISIBLE)
    }
  }

  handleResize() {
    if (this.state.isOpen) {
      this.setHeaderHeight()
    }
  }

  toggle() {
    if (this.state.isAnimating) return

    this.state.isOpen ? this.close() : this.open()
  }

  open() {
    this.state.isAnimating = true
    this.state.isOpen      = true

    const onComplete = () => {
      this.state.isAnimating = false
      this.elm.close[1].removeEventListener(transitionEnd, onComplete)
    }
    this.elm.close[1].addEventListener(transitionEnd, onComplete)

    this.setHeaderHeight()
    this.elm.header.classList.add(this.CLASSNAME.ACTIVE)
  }

  close() {
    this.state.isAnimating = true
    this.state.isOpen      = false

    const onComplete = () => {
      this.elm.header.classList.remove(this.CLASSNAME.LEAVE)
      this.state.isAnimating = false
      this.elm.header.removeEventListener(transitionEnd, onComplete)
    }
    this.elm.header.addEventListener(transitionEnd, onComplete)

    this.elm.header.classList.add(this.CLASSNAME.LEAVE)
    this.elm.header.classList.remove(this.CLASSNAME.ACTIVE)
    this.removeHeaderHeight()
  }

  setHeaderHeight() {
    const scaleY = (window.innerHeight + 50)  / this.headerHeight

    this.elm.header.style.height = window.innerHeight + 'px'
    for (let i = 0, length = this.elm.headerBg.length; i < length; i++) {
      this.elm.headerBg[i].style.transform = `scaleY(${scaleY})`
      this.elm.headerBg[i].style['-webkit-transform'] = `scaleY(${scaleY})`
    }
  }
 
  removeHeaderHeight() {
    this.elm.header.style.height = ''
    for (let i = 0, length = this.elm.headerBg.length; i < length; i++) {
      this.elm.headerBg[i].style.transform = ''
      this.elm.headerBg[i].style['-webkit-transform'] = ''
    }
  }

}


// WEBPACK FOOTER //
// ./src/assets/js/common/NaviSp.js